module.exports = __webpack_public_path__ + "static/media/request_icon_active.fd0f47d3.svg";